export default [
    {name: 'home', ref: "#headerSection"},
    {name: 'products', ref: "#productsSection"},
    {name: 'references', ref: "#referencesSection"},
    {name: 'blog', ref: "blog"},
    {name: 'gdpr', ref: "gdpr"},
    {name: 'imprint', ref: "imprint"},
]
